export const tanimoto = (s1: string, s2: string): number => {
  let includes = 0;
  const s2Letters = new Set(s2);

  for (const letter of s1) {
    includes += +s2Letters.has(letter);
  }

  return includes / (s1.length + s2.length - includes);
};
